<span
  [ngClass]="type() | accountTypeCss | async"
  class="inline-flex items-center rounded-md px-2 py-1 text-sm font-medium ring-1 ring-inset">
  {{ type() | accountTypeLabel | async }}
</span>
